module.exports = __webpack_public_path__ + "static/media/alcon2.dbd97cb5.png";